import { ColorPalette } from "@faro-lotv/flat-ui";
import { type JSX } from "react";
import {
  ANNOTATION_PALETTE,
  AnnotationColor,
  annotationColorToCss,
  cssToAnnotationColor,
} from "./annotation-colors";

type AnnotationColorPaletteProps = {
  /** Selected color, undefined for the default dark pin */
  color?: AnnotationColor;

  onChange(color: AnnotationColor): void;
};

/** @returns the palette of the annotation colors: the dark of the pin, and the Sphere XG colors */
export function AnnotationColorPalette({
  color,
  onChange,
}: AnnotationColorPaletteProps): JSX.Element {
  return (
    <ColorPalette
      dark
      colors={ANNOTATION_PALETTE}
      value={annotationColorToCss(color)}
      onChange={(picked) => {
        // A click on the selected swatch unselects it, which keeps the color as it is
        if (picked) onChange(cssToAnnotationColor(picked));
      }}
    />
  );
}
